import { ContactGenre } from "@/lib/gql/__generated__/graphql";

import { FormAboutGuestReservation } from "./form-about-guest-reservation";
import { FormAboutOther } from "./form-about-others";
import { FormAboutSettings } from "./form-about-settings";
import { SelectGenre } from "./select-category";

import type { ContactCreateInputZodSchemaType } from "../../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<ContactCreateInputZodSchemaType>;
};

export const Form = ({ form }: Props) => {
	const { watch } = form;
	const contactGenre = watch("contactGenre");

	const renderForm = () => {
		switch (contactGenre) {
			case ContactGenre.HostSettings:
				return <FormAboutSettings form={form} />;
			case ContactGenre.GuestReservation:
				return <FormAboutGuestReservation form={form} />;
			case ContactGenre.Others:
				return <FormAboutOther form={form} />;
			default:
				return null;
		}
	};

	return (
		<div>
			<div className="space-y-8">
				<SelectGenre form={form} />

				{renderForm()}
			</div>
		</div>
	);
};

Form.displayName = "Form";
